import { getSettings } from "../../common/settingsProvider.ts";
import { createPdfUrl } from "../../common/pdfUrlHelper.ts";
import { downloadFile } from "../../common/api/downloadFile.ts";
import { createElement, useState } from "react";
import { Trans } from "react-i18next";
import { useUrlProvider } from "../../useUrlProvider.ts";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider.tsx";

export interface IDownloadLegalEntityClassificationReport {
    id: string;
    questionnaireName: string;
    legalEntityName: string;
    questionnaireResponseId: string;
}

export function useDownloadLegalEntityClassificationReport() {
    const snackbar = useDotLegalSnackbar();
    const { language } = useUserContext();
    const { getClassificationQuestionnaireResponseReport } = useUrlProvider();
    const [downloadingPdfIds, setDownloadingPdfIds] = useState<Array<string>>([]);

    function getReportPdfUrl(viewModel: IDownloadLegalEntityClassificationReport, pdf: boolean, showRecommendations: boolean) {
        return getClassificationQuestionnaireResponseReport(viewModel.questionnaireResponseId, viewModel.legalEntityName, pdf, showRecommendations);
    }

    const onDownloadReportAsPdf = async (viewModel: IDownloadLegalEntityClassificationReport, showRecommendations: boolean) => {
        // Functional updates, because several downloads can be in flight at once and each finishes on its own schedule
        setDownloadingPdfIds((ids) => [...ids, viewModel.id]);
        let url = getReportPdfUrl(viewModel, true, showRecommendations);
        url = createPdfUrl(url, language);
        const fileName = `${viewModel.questionnaireName}_${viewModel.legalEntityName}.pdf`;
        await downloadFile(getSettings().apiBaseUrl + "/pdf/generate?noMargin=true&url=" + url, fileName);
        setDownloadingPdfIds((ids) => ids.filter((id) => id !== viewModel.id));
        snackbar.show(createElement(Trans, { i18nKey: "pdfDownloadComplete", values: { fileName: fileName } }));
    };

    function isDownloadingPdf(id: string) {
        return downloadingPdfIds.includes(id);
    }

    return { onDownloadReportAsPdf, getReportPdfUrl, isDownloadingPdf };
}
